import styled from 'styled-components';

import { CellContent } from './CellContent';

export const CellContentFlex = styled(CellContent)`
  display: flex;
  gap: 10px;
  align-items: center;
`;
